export default __webpack_public_path__ + "static/media/DAIF_Services_Screen5_in.23f973eb.mp4";